import React, { JSX } from "react";
import { useNavigate } from "react-router";
import { useUser } from "../../hooks/useUser";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useUserContext } from "../../contexts/UserContext";
import { useUserDefaultForm } from "../../hooks/useUserDefaultForm";
import { User } from "../../models/user/User";
import FirebaseService from "../../actions/firebase/FirebaseActions";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

export const UserEntryRow = ({
  userId,
  highlighted = false
}: {
  userId: string;
  highlighted?: boolean;
}): JSX.Element => {
  const navigate = useNavigate();
  const { user } = useUser(userId);
  const { user: firebaseAuthUser } = useAuthUser();
  const { setActiveUser } = useUserContext();
  const [defaultForm] = useUserDefaultForm(firebaseAuthUser?.uid || "");

  if (!firebaseAuthUser) {
    return <></>;
  }

  const isDefault = defaultForm?.formOwnerId === userId;

  const handleUserSelect = (user?: User): void => {
    if (!user) {
      return;
    }
    setActiveUser(user);
    navigate(`/user/${user.id}/dashboard`);
  };

  const handleSetDefaultForm = async (userId: string): Promise<void> => {
    try {
      await FirebaseService.setDefaultFormOwner(firebaseAuthUser.uid, userId);
      toast.success("Standard-Formular erfolgreich gesetzt");
    } catch (error) {
      console.error("Error setting default form:", error);
      toast.error("Fehler beim Setzen des Standard-Formulars");
    }
  };

  return (
    <tr style={highlighted ? { fontWeight: 600 } : undefined}>
      <td onClick={() => handleUserSelect(user)} style={{ cursor: "pointer" }}>
        {user?.userProfile?.name}
        {isDefault && <FontAwesomeIcon icon={faStar} className="text-warning ms-2" />}
      </td>
      <td onClick={() => handleUserSelect(user)} style={{ cursor: "pointer" }}>
        {user?.userProfile?.email || user?.email}
      </td>
      <td>
        <Button
          size="sm"
          variant={isDefault ? "success" : "outline-primary"}
          onClick={() => void handleSetDefaultForm(userId)}
          disabled={isDefault}>
          {isDefault ? "Standard" : "Als Standard setzen"}
        </Button>
      </td>
    </tr>
  );
};
